import {
  OVERVIEW_ACCENTS,
  type OverviewAccent
} from "../overview/OverviewCardIcon.tsx"

const ACCENT_KEYS = Object.keys(OVERVIEW_ACCENTS) as OverviewAccent[]

/**
 * Deterministic per-author avatar color from the same pastel accent palette
 * Lead Overview cards already use — the same author always gets the same
 * avatar color across reloads, independent of the note's own category color.
 * Mirrors `CustomersPage/.../customer-avatar-accent.ts`'s hash.
 */
const accentForAuthor = (seed: string): OverviewAccent => {
  let hash = 0
  for (let i = 0; i < seed.length; i++)
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0
  return ACCENT_KEYS[hash % ACCENT_KEYS.length]
}

export { accentForAuthor }
